import React, { useEffect } from 'react';
// import { NavLink } from 'react-router-dom';
import './OurServices.css';

const services = [
  {
    title: 'Full Home & Commercial Renovation & Remodel',
    icon: require('./../../images/service-icons/home-commercial.png'),
    description: 'Complete end-to-end revamps for residential and commercial spaces.',
  },
  {
    title: 'Kitchen Renovation',
    icon: require('./../../images/service-icons/kitchen.png'),
    description: 'Modern kitchens built for style, function, and everyday living.',
  },
  {
    title: 'Bathroom Renovation',
    icon: require('./../../images/service-icons/bathroom.png'),
    description: 'Clean, durable bathroom upgrades focused on comfort and usability.',
  },
  {
    title: 'Basement Renovation & Remodel',
    icon: require('./../../images/service-icons/basement.png'),
    description: 'Transform unused lower levels into practical, finished living areas.',
  },
  {
    title: 'Interior Finishing & Carpentry',
    icon: require('./../../images/service-icons/interior-finishing.png'),
    description: 'Detailed trim, millwork, and finishing touches that elevate each room.',
  },
  {
    title: 'Flooring Installation',
    icon: require('./../../images/service-icons/flooring.png'),
    description: 'Quality flooring installed with precision for long-term performance.',
  },
  {
    title: 'Electrical, Plumbing & HVAC',
    icon: require('./../../images/service-icons/mechanical.png'),
    description: 'Reliable core systems for safer, more efficient home operation.',
  },
  {
    title: 'Structural & Framing Work',
    icon: require('./../../images/service-icons/structural.png'),
    description: 'Solid framing and structural reinforcement to support lasting builds.',
  },
  {
    title: 'Exterior & Outdoor Renovations',
    icon: require('./../../images/service-icons/exterior.png'),
    description: 'Outdoor improvements that increase curb appeal and usable exterior space.',
  }
]

var img1 = require('./../../images/background/bg-5.png');

const OurServices = () => {
  useEffect(() => {
    function loadScript(src) {

      return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = src;
        script.addEventListener('load', function () {
          resolve();
        });
        script.addEventListener('error', function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      })
    };

    loadScript('./assets/js/masonary.js');

  }, []);

  return (
    <>
      <div className="section-full p-t80 p-b50 bg-white mobile-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
        <div className="container">
          {/* TITLE START */}
          <div className="section-head">
            <div className="mt-separator-outer separator-center">
              <div className="mt-separator">
                <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">All</span> Services</h2>
              </div>
            </div>
          </div>
          {/* TITLE END */}
          {/* IMAGE CAROUSEL START */}
          <div className="section-content">
            <div className="our-services-grid">
              {services.map((item, index) => (
                <div key={index} className="our-services-grid__cell text-center">
                  <div className="mt-icon-box-wraper p-a30 center box-shadow bg-white">
                    <div className="our-services-icon-wrap m-b20">
                      <img className="our-services-icon" src={item.icon} alt={item.title} />
                    </div>
                    <div className="icon-content text-center">
                      <h4 className="mt-tilte text-uppercase font-weight-600 m-b20">{item.title}</h4>
                      <p>{item.description}</p>
                      {/* <NavLink to={"/services"} className="site-button-link" data-hover="Read More">Read More <i className="fa fa-angle-right arrow-animation" /></NavLink> */}
                    </div>
                  </div>
                </div>
              ))}

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurServices;
